<template>
  <div class="order-item-btn-list">
    <div class="order-operate-btn">
      <template v-if="templateMaterialList && templateMaterialList.length > 0">
        <el-select
          popper-class="custom-select-max-width"
          v-model="selectedTemplateIndex"
          placeholder="选择资料"
        >
          <el-option
            v-for="item in templateMaterialOptionList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>

      <div
        class="btn ghost"
        v-if="templateMaterialList && templateMaterialList.length > 0"
        @click="sendMaterial()"
      >
        发送模板
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/services/tools';

export default {
  props: {
    orderItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedTemplateIndex: 0,
    };
  },
  computed: {
    templateMaterialList() {
      return this.orderItem && this.orderItem.template_material_set
        ? this.orderItem.template_material_set
        : [];
    },
    templateMaterialOptionList() {
      if (!this.templateMaterialList || !this.templateMaterialList.length)
        return [];
      return this.templateMaterialList.map((item, index) => ({
        label: item.name,
        value: index,
      }));
    },
  },
  methods: {
    // 发送模板
    async sendMaterial() {
      try {
        if (!this.templateMaterialList || !this.templateMaterialList.length)
          return;
        const result = this.templateMaterialList[this.selectedTemplateIndex];
        if (result) {
          const copyText = `${this.orderItem.product_name}_资料模板_${result.name}: \n${result.template}`;
          ww.setClipboardData({
            data: copyText,
            success() {},
          });
        } else {
          utils.showError('该资料类型的对应模板不存在');
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="less">
.custom-select-max-width {
  max-width: 160px;
}
.order-operate-btn {
  .el-select .el-input__inner {
    width: 116px;
    max-width: 120px;
    height: 32px;
    line-height: 32px;
  }
  .el-input__icon {
    line-height: 32px;
  }
}
</style>
<style lang="less" scoped>
.order-operate-btn {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;

  .template-select {
    border: 1px solid #ddd;
    max-width: 160px;
    padding: 0 4px;
    color: #606266;
    .template-select-option {
      font-size: 14px;
      padding: 0 24px;
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #606266;
      height: 45px;
      line-height: 45px;
      box-sizing: border-box;
      cursor: pointer;
      // 选中样式无法更改---只能去找模拟实现
      &::checked {
        color: #409eff;
        font-weight: 700;
        background-color: red;
      }
    }
  }

  .select-material {
    width: 80px;
    height: 24px;
    line-height: 24px;
    margin-right: 10px;
  }

  .btn {
    width: 80px;
    height: 32px;
    line-height: 30px;
    font-size: 14px;
    text-align: center;
    border-radius: 4px;

    &.ghost {
      border: 1px solid #3fa2f5;
      color: #3fa2f5;
      margin: 0 9px;
    }
    &.primary {
      color: #fff;
      background-color: #3fa2f5;
      margin-right: 15px;
    }
  }
  &:hover {
    cursor: pointer;
  }
}
</style>
